<template>
  <div>
    <!-- 上传失败 开始 -->
    <div class="upload-fail"
         v-if="failShow">
      <i class="iconfont icon-sp_fail"></i>
      <p>文件上传失败</p>
      <p>请重新上传</p>
      <el-button @click="failShow=false">确定</el-button>
    </div>
    <!-- 上传失败 结束 -->
  </div>
</template>
<script>
export default {
  name: 'uploadfail',
  data() {
    return {
      failShow: true
    }
  },
  methods: {
  }
}
</script>
<style lang="scss">
.upload-fail {
  width: 398px;
  border-radius: 2px;
  background: #fff;
  padding: 30px 0;

  i {
    font-size: 50px;
  }

  p:nth-child(2) {
    color: #003580;
    font-family: "Microsoft YaHei-Bold";
    font-size: 18px;
  }

  p:nth-child(3) {
    margin-top: 16px;
    font-size: 14px;
    color: #666;
  }

  p:nth-child(4) {
    margin-top: 10px;
    font-size: 14px;
    color: #333;
  }

  .el-button {
    width: 148px;
    height: 36px;
    line-height: 36px;
    font-size: 14px;
    color: #fff;
    background: #2d61a8;
    border-radius: 2px;
    margin-top: 30px;
    padding: 0;
    border: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mind/uploadFail.vue